import { gql } from 'graphql-request'

export const GET_WRITER_SALES_ANALYTICS_EBOOK_OVERVIEW = gql`
  query GetWriterSalesAnalyticsEbookOverview(
    $getWriterSalesAnalyticsEbookOverviewInput: GetWriterSalesAnalyticsEbookOverviewInput!
  ) {
    getWriterSalesAnalyticsEbookOverview(
      getWriterSalesAnalyticsEbookOverviewInput: $getWriterSalesAnalyticsEbookOverviewInput
    ) {
      ebookTitle
      ebookType
      purchasedCount
      readTrialChapterCount
      sales
      viewCount
    }
  }
`
